/*
  Amary Academy Accessibility Helper for Shopify — Gold v3
  Add to: assets/amary-accessibility.js
*/

(function () {
  "use strict";

  var STORAGE_KEY = "amaryShopifyAccessibilityPrefs";
  var root = document.documentElement;
  var RUNTIME_STYLE_ID = "amary-a11y-runtime-style";

  var CLASSES = [
    "amary-a11y-text-lg",
    "amary-a11y-text-xl",
    "amary-a11y-readable-font",
    "amary-a11y-underline-links",
    "amary-a11y-high-contrast",
    "amary-a11y-dark-readable",
    "amary-a11y-reduce-motion"
  ];

  var runtimeCss = `
    html.amary-a11y-text-lg body :where(p, li, summary, label, input, select, textarea, button, a, .rte, .rte *, .product__description, .product__description *, .product-form *, .price *, .card-information *, .footer *, .drawer *, .cart-drawer *, .menu-drawer *) {
      font-size: max(1em, 18px) !important;
      line-height: 1.7 !important;
    }

    html.amary-a11y-text-xl body :where(p, li, summary, label, input, select, textarea, button, a, .rte, .rte *, .product__description, .product__description *, .product-form *, .price *, .card-information *, .footer *, .drawer *, .cart-drawer *, .menu-drawer *) {
      font-size: max(1.12em, 20px) !important;
      line-height: 1.8 !important;
    }


    html.amary-a11y-text-lg .amary-a11y-widget,
    html.amary-a11y-text-lg .amary-a11y-widget *,
    html.amary-a11y-text-xl .amary-a11y-widget,
    html.amary-a11y-text-xl .amary-a11y-widget * {
      font-size: 15px !important;
      line-height: 1.25 !important;
    }

    html.amary-a11y-text-lg .amary-a11y-widget h2,
    html.amary-a11y-text-xl .amary-a11y-widget h2 {
      font-size: 18px !important;
      line-height: 1.25 !important;
    }

    html.amary-a11y-text-lg .amary-a11y-widget .amary-a11y-toggle,
    html.amary-a11y-text-xl .amary-a11y-widget .amary-a11y-toggle {
      font-size: 24px !important;
      line-height: 1 !important;
    }

    html.amary-a11y-text-lg .amary-a11y-widget .amary-a11y-note,
    html.amary-a11y-text-xl .amary-a11y-widget .amary-a11y-note {
      font-size: 12px !important;
      line-height: 1.45 !important;
    }

    html.amary-a11y-readable-font body,
    html.amary-a11y-readable-font body * {
      font-family: Arial, Helvetica, sans-serif !important;
      letter-spacing: 0.012em !important;
      line-height: 1.72 !important;
    }

    html.amary-a11y-high-contrast body,
    html.amary-a11y-high-contrast :where(header, footer, main, section, article, aside, nav, .shopify-section, .page-width, .card, .card-wrapper, .product-card-wrapper, .product, .product__info-wrapper, .product__info-container, .product-form, .product__accordion, .accordion, details, summary, .drawer, .drawer__inner, .cart-drawer, .modal, .popup, .menu-drawer, .search-modal, .predictive-search, .newsletter, .footer, .jdgm-widget, .spr-container) {
      background: #ffffff !important;
      background-color: #ffffff !important;
      color: #111111 !important;
      border-color: #111111 !important;
      box-shadow: none !important;
      text-shadow: none !important;
    }

    html.amary-a11y-high-contrast :where(h1,h2,h3,h4,h5,h6,p,li,span,strong,em,small,label,legend,summary,blockquote,div,th,td,.price,.price *,.money,.product__title,.product__description,.product__description *,.product__text,.card__heading,.card__heading *,.card-information,.card-information *,.caption,.badge,.rte,.rte *,.jdgm-widget *,.spr-container *,.drawer *,.cart-drawer *,.menu-drawer *) {
      color: #111111 !important;
      text-shadow: none !important;
    }

    html.amary-a11y-high-contrast :where(.button, .btn, button, button[type="button"], button[type="submit"], input[type="submit"], .shopify-payment-button__button, .product-form__submit, .cart__checkout-button, .cart-drawer .button, .drawer .button, .coupon button, .customer button, .jdgm-write-rev-link, .spr-button) {
      background: #000000 !important;
      background-color: #000000 !important;
      color: #ffffff !important;
      border: 2px solid #000000 !important;
      opacity: 1 !important;
      box-shadow: none !important;
    }

    html.amary-a11y-high-contrast :where(.button *, .btn *, button *, input[type="submit"] *, .shopify-payment-button__button *, .product-form__submit *, .cart__checkout-button *, .cart-drawer .button *, .drawer .button *, .coupon button *, .jdgm-write-rev-link *, .spr-button *) {
      color: #ffffff !important;
      fill: #ffffff !important;
      stroke: #ffffff !important;
    }

    html.amary-a11y-dark-readable body,
    html.amary-a11y-dark-readable :where(header, footer, main, section, article, aside, nav, .shopify-section, .page-width, .card, .card-wrapper, .product-card-wrapper, .product, .product__info-wrapper, .product__info-container, .product-form, .product__accordion, .accordion, details, summary, .drawer, .drawer__inner, .cart-drawer, .modal, .popup, .menu-drawer, .search-modal, .predictive-search, .newsletter, .footer, .jdgm-widget, .spr-container) {
      background: #111111 !important;
      background-color: #111111 !important;
      color: #ffffff !important;
      border-color: #777777 !important;
      box-shadow: none !important;
      text-shadow: none !important;
    }

    html.amary-a11y-dark-readable :where(h1,h2,h3,h4,h5,h6,p,li,span,strong,em,small,label,legend,summary,blockquote,div,th,td,.price,.price *,.money,.product__title,.product__description,.product__description *,.product__text,.card__heading,.card__heading *,.card-information,.card-information *,.caption,.badge,.rte,.rte *,.jdgm-widget *,.spr-container *,.drawer *,.cart-drawer *,.menu-drawer *) {
      color: #ffffff !important;
      text-shadow: none !important;
    }

    html.amary-a11y-dark-readable :where(.button, .btn, button, button[type="button"], button[type="submit"], input[type="submit"], .shopify-payment-button__button, .product-form__submit, .cart__checkout-button, .cart-drawer .button, .drawer .button, .coupon button, .customer button, .jdgm-write-rev-link, .spr-button) {
      background: #ffffff !important;
      background-color: #ffffff !important;
      color: #000000 !important;
      border: 2px solid #ffffff !important;
      opacity: 1 !important;
      box-shadow: none !important;
    }

    html.amary-a11y-dark-readable :where(.button *, .btn *, button *, input[type="submit"] *, .shopify-payment-button__button *, .product-form__submit *, .cart__checkout-button *, .cart-drawer .button *, .drawer .button *, .coupon button *, .jdgm-write-rev-link *, .spr-button *) {
      color: #000000 !important;
      fill: #000000 !important;
      stroke: #000000 !important;
    }
  `;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function injectRuntimeStyle() {
    if (document.getElementById(RUNTIME_STYLE_ID)) return;
    var style = document.createElement("style");
    style.id = RUNTIME_STYLE_ID;
    style.textContent = runtimeCss;
    document.head.appendChild(style);
  }

  function getPrefs() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (error) {
      return {};
    }
  }

  function savePrefs(prefs) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    } catch (error) {}
  }

  function applyPrefs() {
    var prefs = getPrefs();

    CLASSES.forEach(function (className) {
      root.classList.toggle(className, Boolean(prefs[className]));
      document.body && document.body.classList.toggle(className, Boolean(prefs[className]));
    });

    document.querySelectorAll("[data-amary-a11y]").forEach(function (button) {
      var className = button.getAttribute("data-amary-a11y");
      button.setAttribute("aria-pressed", prefs[className] ? "true" : "false");
    });
  }

  function togglePref(className) {
    var prefs = getPrefs();

    if (className === "amary-a11y-text-lg") {
      prefs["amary-a11y-text-xl"] = false;
    }

    if (className === "amary-a11y-text-xl") {
      prefs["amary-a11y-text-lg"] = false;
    }

    if (className === "amary-a11y-high-contrast") {
      prefs["amary-a11y-dark-readable"] = false;
    }

    if (className === "amary-a11y-dark-readable") {
      prefs["amary-a11y-high-contrast"] = false;
    }

    prefs[className] = !prefs[className];
    savePrefs(prefs);
    applyPrefs();

    /* Force late re-apply after Shopify sections/apps repaint. */
    window.setTimeout(applyPrefs, 80);
    window.setTimeout(applyPrefs, 350);
  }

  function getFocusable(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return element.offsetParent !== null || element === document.activeElement;
    });
  }

  function trapFocus(event, container) {
    if (event.key !== "Tab") return;

    var focusable = getFocusable(container);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function ensureMainContentTarget() {
    var skipLink = document.querySelector(".amary-skip-link");
    var main =
      document.getElementById("MainContent") ||
      document.querySelector("main") ||
      document.querySelector('[role="main"]');

    if (!main || !skipLink) return;

    if (!main.id) main.id = "MainContent";
    main.setAttribute("tabindex", "-1");

    skipLink.setAttribute("href", "#" + main.id);
    skipLink.addEventListener("click", function () {
      window.setTimeout(function () {
        main.focus({ preventScroll: true });
      }, 0);
    });
  }

  function initPanel() {
    var widget = document.getElementById("amary-a11y-widget");
    var panel = document.getElementById("amary-a11y-panel");
    var toggle = widget ? widget.querySelector(".amary-a11y-toggle") : null;
    var reset = document.getElementById("amary-a11y-reset");

    if (!widget || !panel || !toggle) return;

    function setOpen(open) {
      panel.hidden = !open;
      toggle.setAttribute("aria-expanded", String(open));
      toggle.setAttribute("aria-label", open ? "Close accessibility options" : "Open accessibility options");

      if (open) {
        var first = panel.querySelector("button");
        if (first) first.focus();
      }
    }

    toggle.addEventListener("click", function () {
      setOpen(panel.hidden);
    });

    document.querySelectorAll("[data-amary-a11y]").forEach(function (button) {
      button.addEventListener("click", function () {
        togglePref(button.getAttribute("data-amary-a11y"));
      });
    });

    if (reset) {
      reset.addEventListener("click", function () {
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch (error) {}
        applyPrefs();
      });
    }

    document.addEventListener("click", function (event) {
      if (!panel.hidden && !widget.contains(event.target)) {
        setOpen(false);
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !panel.hidden) {
        setOpen(false);
        toggle.focus();
      }

      if (!panel.hidden) {
        trapFocus(event, panel);
      }
    });
  }

  function initStatementModal() {
    var openButton = document.getElementById("amary-accessibility-statement-open");
    var modal = document.getElementById("amary-accessibility-statement");
    var modalCard = modal ? modal.querySelector(".amary-a11y-modal-card") : null;
    var closeButtons = modal ? modal.querySelectorAll("[data-amary-a11y-close]") : [];
    var lastFocused = null;

    if (!openButton || !modal || !modalCard) return;

    function openModal() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      document.body.classList.add("amary-a11y-lock");
      openButton.setAttribute("aria-expanded", "true");

      window.setTimeout(function () {
        modalCard.focus();
      }, 0);
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove("amary-a11y-lock");
      openButton.setAttribute("aria-expanded", "false");

      if (lastFocused && typeof lastFocused.focus === "function") {
        lastFocused.focus();
      }
    }

    openButton.setAttribute("aria-haspopup", "dialog");
    openButton.setAttribute("aria-controls", "amary-accessibility-statement");
    openButton.setAttribute("aria-expanded", "false");
    openButton.addEventListener("click", openModal);

    closeButtons.forEach(function (button) {
      button.addEventListener("click", closeModal);
    });

    document.addEventListener("keydown", function (event) {
      if (modal.hidden) return;

      if (event.key === "Escape") {
        event.preventDefault();
        closeModal();
        return;
      }

      trapFocus(event, modal);
    });
  }

  function hardenCommonShopifyAccessibility() {
    document.querySelectorAll('a[target="_blank"]').forEach(function (link) {
      var rel = (link.getAttribute("rel") || "").split(/\s+/);
      if (rel.indexOf("noopener") === -1) rel.push("noopener");
      if (rel.indexOf("noreferrer") === -1) rel.push("noreferrer");
      link.setAttribute("rel", rel.join(" ").trim());

      var label = link.getAttribute("aria-label") || link.textContent.trim();
      if (label && !/opens in a new tab/i.test(label)) {
        link.setAttribute("aria-label", label + " - opens in a new tab");
      }
    });

    document.querySelectorAll("img:not([alt])").forEach(function (img) {
      img.setAttribute("alt", "");
    });

    document.querySelectorAll("svg:not([aria-hidden]):not([role])").forEach(function (svg) {
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("focusable", "false");
    });

    document.querySelectorAll("details").forEach(function (details, index) {
      var summary = details.querySelector("summary");
      if (!summary) return;

      if (!summary.id) summary.id = "amary-details-summary-" + index;

      Array.prototype.slice.call(details.children).forEach(function (child) {
        if (child === summary) return;
        if (!child.getAttribute("role")) child.setAttribute("role", "region");
        if (!child.getAttribute("aria-labelledby")) child.setAttribute("aria-labelledby", summary.id);
      });
    });
  }

  function observeShopifySectionUpdates() {
    var observer = new MutationObserver(function () {
      applyPrefs();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  ready(function () {
    injectRuntimeStyle();
    ensureMainContentTarget();
    initPanel();
    initStatementModal();
    hardenCommonShopifyAccessibility();
    applyPrefs();
    observeShopifySectionUpdates();
  });
})();
